<template>
  <div class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1">
    <div class="p-2">
      <!--<b-button
        v-if="view !== 'dashboard'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="primary"
        block
        @click="$emit('update:isEventHandlerSidebarActive', true)"
      >
        Add Event
      </b-button>-->
      <div :class="view !== 'dashboard' ? 'mt-3' : null">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Calendarios</span>
        </h5>

        <b-form-checkbox
          v-model="checkAll"
          class="mb-1"
          :style="{'custom-control-input:checked': '#D7B1D7','custom-control-label::before': '#D7B1D7'}"
        >
          Ver Todos
        </b-form-checkbox>
        <hr>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCalendars"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="item in calendarOptions"
              :key="item.label"
              name="event-filter"
              :value="item"
              class="mb-1"
              :class="`custom-control-${item.color}`"
            >
              <b-avatar
                size="sm"
                :src="item.photoUrl"
              />
              {{ item.resourceName }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>
    <b-img :src="require('@/assets/images/pages/calendar-illustration.png')" />
  </div>
</template>
<style lang="css">

</style>

<script>
import {
  BAvatar, BButton, BFormGroup, BFormCheckboxGroup, BFormCheckbox, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useCalendarSidebar from './useCalendarSidebar'

export default {
  directives: {
    Ripple,
  },
  components: {
    BAvatar,
    BButton,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
    view: {
      type: String,
      default: '',
    },
  },
  setup() {
    const {
      calendarOptions,
      selectedCalendars,
      checkAll,
    } = useCalendarSidebar()

    return {
      calendarOptions,
      selectedCalendars,
      checkAll,
    }
  },
}
</script>

<style>

</style>
